import { Injectable } from '@angular/core';

import { EncryDecryService } from './encrydecry.service';
//import { EncryDecryService } from './../_core/services';
@Injectable({
  providedIn: 'root',
})
export class WebStorageService {
  constructor(private encryDecryService: EncryDecryService) {}
  
  /**
   * Sets the encryption key for the session.
   * SECURITY NOTE: This key is derived from the username and used for encrypting session data.
   * 
   * IMPORTANT SECURITY CONSIDERATIONS:
   * - Uses sessionStorage instead of localStorage for better security
   * - sessionStorage is cleared when browser tab/window is closed
   * - localStorage persists across sessions, increasing XSS attack window
   * - Still vulnerable to XSS attacks during active session
   * - Server-side encryption/decryption is the only truly secure solution
   * - This is defense-in-depth, not primary security mechanism
   * 
   * @param key - Username or identifier to derive encryption key from
   */
  setKey(key: string) {
    // SECURITY: Generate encryption key from username
    const modifiedkey = this.encryDecryService.setKey(key);
    
    // SECURITY: Store in sessionStorage (not localStorage) to limit exposure window
    // sessionStorage is automatically cleared when tab/window closes
    // This reduces the attack surface for XSS vulnerabilities
    window.sessionStorage.setItem('_temp', this.encryDecryService.encode(modifiedkey));
    
    // SECURITY WARNING: Client-side encryption provides limited protection
    // Sensitive data should be managed server-side with proper authentication tokens
  }

  /**
   * Retrieves the encryption key from session storage.
   * SECURITY: Returns null if key doesn't exist, preventing errors on page reload
   * @returns Encryption key or null
   */
  getKey(): string | null {
    return window.sessionStorage.getItem('_temp');
  }
  setItemInLocalStorage(key: string, value: any) {
    if (!key) return;
    try {
      const payload = JSON.stringify(value);
      const encrypted = this.encryDecryService.encrypt(payload);
      if (encrypted) window.localStorage.setItem(key, encrypted);
    } catch (err) {
      // ignore storage failures
    }
  }
  getItemFromLocalStorage(key: string) {
    if (!key) return null;
    try {
      const raw = window.localStorage.getItem(key);
      if (!raw) return null;
      const decrypted = this.encryDecryService.decrypt(raw);
      return decrypted;
    } catch (err) {
      return null;
    }
  }
  setItemInSessionStorage(key: string, value: any) {
    if (!key) return;
    try {
      const payload = JSON.stringify(value);
      const encrypted = this.encryDecryService.encrypt(payload);
      if (encrypted) sessionStorage.setItem(key, encrypted);
    } catch (err) {
      // ignore storage failures
    }
  }
  getItemFromSessionStorage(key: string) {
    if (!key) return null;
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      const decrypted = this.encryDecryService.decrypt(raw);
      return decrypted;
    } catch (err) {
      return null;
    }
  }
  
}
